import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Product } from '@schoolbelle/api/purchase';
import { merge } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { SelectAbstractComponent, ProductParams } from '../select-abstract';
import { PurchaseService } from '@schoolbelle/api/purchase';
import { times } from 'lodash-es';



@Component({
  selector: 'app-select-license',
  templateUrl: './select-license.component.html',
  styleUrls: ['./select-license.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class SelectLicenseComponent extends SelectAbstractComponent implements OnInit {
  @Input() form:FormGroup;
  @Input() required:boolean = false;
  @Input() products:ProductParams[] = [];
  @Output() productsChange = new EventEmitter<ProductParams[]>();

  protected purchaseType:FormControl;
  protected months:FormControl;

  sizeup_xs:Product;
  sizeup:Product;
  sizeup_by_student:Product;
  basic_fee:Product;

  oldProducts:Product[] = []
  constructor (
    purchase:PurchaseService,
    @Inject(LOCALE_ID) public locale_id:string,
  ) {
    super(purchase);
  }



  getConsecutiveNumbers (length:number) {
    return times(length);
  }

  protected setProducts () {
    this.sizeup_xs = this.purchase.currentProducts.find(product=>{
      return [52].includes(product.product_id);
    });
    this.sizeup = this.purchase.currentProducts.find(product=>{
      return [51].includes(product.product_id);
    });

    this.sizeup_by_student = this.purchase.currentProducts.find(product=>{
      return [63].includes(product.product_id);
    });
    this.basic_fee = this.purchase.currentProducts.find(product=>{
      return [50].includes(product.product_id);
    });
  }
  protected setOldProducts () {
    const is_first = this.purchaseType.value === 'first';
    if (is_first) this.oldProducts = this.purchase.currentProducts.filter(p=>![25,26,27,28,29,30].includes(p.product_id) && p.product_id <= 49 && (<any>p).type.includes('license'));
    else this.oldProducts = this.purchase.currentProducts.filter(p=>![31,32,33,34,35,36].includes(p.product_id) && p.product_id <= 49 && (<any>p).type.includes('license'));

  }
  protected watch () {
    this.subscriptions.add(
      merge(
        this.purchaseType.valueChanges,
        this.months.valueChanges,
      )
      .pipe(
        startWith(null),
      )
      .subscribe(()=>{
        this.setOldProducts();
        this.onUpdate(this.indexCtrl.value);
      })
    );    
  }


  ngOnInit(): void {
    this.purchaseType = this.form.get('buyerInfo.purchaseType') as FormControl;
    this.months = this.form.get('months') as FormControl;
    this.setProducts();
    this.setOldProducts();

    super.ngOnInit();

    this.setIndex();

    this.watch();

    

  }
  getSmsPromotionAmount (index:number):number {
    if (typeof index === 'number') {
      const months:number = this.months.value;
      if (index === 0) return 20 * months;
      else {
        return 48 * index * months;
      }
    }
    else {
      return 0;
    }

  }  
  onUpdate (index:number|Product) {
    if (typeof index === 'number' || index === null) {
      let products:ProductParams[] = [];
    
      // add or remove basic fee 
      if (typeof index === 'number') products.push({productId:50, quantity:1});
  
      // add or remove size-up
      if (typeof index === 'number') {
        if (this.locale_id.slice(0,2) !== 'vi') {
          if (index === 0) {
            products.push({productId:52, quantity:1});
          }
          else {
            products.push({productId:51, quantity:index});
          }
        }
        else {
          products.push({productId:63, quantity:index});
        }
      }    
      
      // add or remove sms promotion
      if (typeof index === 'number') {
        if (this.locale_id.slice(0,2) !== 'vi') products.push({productId:58, quantity:1, amount:this.getSmsPromotionAmount(index)});
      }
      
      this.products = products;
      this.productsChange.next(this.products);    
    }
    else {

      if (this.oldProducts.find(p=>p.product_id === index.product_id)) {
        this.products = [{productId:index.product_id, quantity:1}];
      }
      else {
        this.products = [];        
      }
      this.productsChange.next(this.products);        
    }  
  }  
  protected setIndex () {
    const sizeup = this.products.find(p=>p.productId === 51);
    const sizeup_xs = this.products.find(p=>p.productId === 52);
    if (sizeup) {
      this.indexCtrl.setValue(sizeup.quantity)
    }
    else if (sizeup_xs) {
      this.indexCtrl.setValue(0);
    }
    else if (this.products.length) {
      const product_id = this.products[0].productId;
      const product = this.purchase.currentProducts.find(p=>p.product_id === product_id);
      if (product) {
        this.indexCtrl.setValue(product);
      }
    }
  }    
}
